// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__3UpVx","Details":"Avatar_Details__1NRg7"};